import { Modal } from 'react-bootstrap';
import type { VoidFunctionComponent } from 'react';

import type { ModalProps } from '..';

import BinaryMatchDetailsContent from './BinaryMatchDetailsContent';

type BinaryMatchModalProps = ModalProps;

const BinaryMatchDetailsModal: VoidFunctionComponent<BinaryMatchModalProps> = ({ modals, projectRevision }) => {
  const { isOpen, onClose } = modals.viewBinaryMatchDetailsModal;
  const { revision } = modals.viewBinaryMatchDetailsModal.context;

  return (
    <Modal onHide={onClose} show={isOpen}>
      <Modal.Header>
        <Modal.Title>Match Details</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <BinaryMatchDetailsContent projectRevision={projectRevision} revision={revision as string} />
      </Modal.Body>
    </Modal>
  );
};

const BinaryMatchDetailsModalContainer: VoidFunctionComponent<BinaryMatchModalProps> = ({
  modals,
  projectRevision,
}) => {
  const { isOpen } = modals.viewBinaryMatchDetailsModal;
  const { revision } = modals.viewBinaryMatchDetailsModal.context;

  if (!isOpen || !revision || !projectRevision) {
    return null;
  }

  return <BinaryMatchDetailsModal modals={modals} projectRevision={projectRevision} />;
};

export default BinaryMatchDetailsModalContainer;
